import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lj/dev/github/scroll-polyfill/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "scroll-polyfill"
    }}>{`scroll-polyfill`}</h1>
    <p>{`Scroll opitons polyfill:`}</p>
    <ul>
      <li parentName="ul">{`Add `}<a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/ScrollToOptions"
        }}><inlineCode parentName="a">{`ScrollToOptions`}</inlineCode></a>{` polyfill for `}<inlineCode parentName="li">{`Element.protype.{scroll|scrollTo|scrollBy}`}</inlineCode>{`, `}<inlineCode parentName="li">{`window.{scroll|scrollTo|scrollBy}`}</inlineCode></li>
      <li parentName="ul">{`Add `}<a parentName="li" {...{
          "href": "https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollInToView"
        }}><inlineCode parentName="a">{`ScrollIntoViewOptions`}</inlineCode></a>{` polyfill for `}<inlineCode parentName="li">{`Element.protype.scrollIntoView`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install scroll-polyfill
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <h3 {...{
      "id": "polyfill"
    }}>{`Polyfill`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import scrollPolyfill from 'scroll-polyfill'

scrollPolyfill()

// or you can force the polyfill (skiping feature detection)
scrollPolyfill({force: true})

// use ScrollToOptions
window.scroll({behavior: 'smooth', left: 100, top: 100})
scroller.scrollBy({behavior: 'smooth', top: 100})

// use ScrollIntoViewOptions
scrollerChild.scrollIntoView({
  behavior: 'smooth',
  block: 'nearest',
  inline: 'start',
})
document.body.scrollIntoView(false)
`}</code></pre>
    <h3 {...{
      "id": "ponyfill"
    }}><a parentName="h3" {...{
        "href": "https://ponyfill.com/"
      }}>{`Ponyfill`}</a></h3>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {scrollTo, scrollBy, scrollIntoView} from 'scroll-polyfill'

scrollTo(window, {behavior: 'smooth', top: 100})
scrollBy(document.scrollingElement, {behavior: 'smooth', top: 100})
scrollIntoView(scrollerChild, {
  behavior: 'smooth',
  block: 'nearest',
  inline: 'start',
})
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      